import React, { useEffect} from 'react'

import DashAuthWrapper from './../components/DashAuthWrapper'

const VendorInvoices = props => {


	useEffect(() => {
		window.scrollTo(0, 0)
	  }, [])
	
	const congfigAuthWrapper = {
		headline: 'Vendor Invoices'
	}
	
	return (
		<DashAuthWrapper {...congfigAuthWrapper}>
				<h4>Some Invoices</h4>

		
		</DashAuthWrapper>


		
	)
}

export default VendorInvoices;